
import axiosInstance from "@/api/axiosInstance";
import type { GetCustomerResponse, Customer, GetCustomerDetailResponse } from "@/types/customer.type";

export const getCustomers = async (email: string): Promise<Customer[]> => {
    try {
        const response = await axiosInstance.get<GetCustomerResponse>(
            `/kasir/customer?email=${email}`
        );

        if (response.data.success) {
            return response.data.data?.customer || [];
        }

        throw new Error("Gagal mengambil Data Customer");
    } catch (error) {
        console.error("getCustomers error:", error);
        throw error;
    }
};

export const getCustomersKasir = async (email: string, name?: string | null): Promise<Customer[]> => {

    if (!email || !name) return [];
    try {
        const response = await axiosInstance.get<GetCustomerResponse>(
            `/kasir/customer?email=${email}&cust_name=${name}`
        );

        if (response.data.success) {
            return response.data.data?.customer || [];
        }

        throw new Error("Gagal mengambil Data Customer");
    } catch (error) {
        console.error("getCustomers error:", error);
        throw error;
    }
};

export const getCustomerDetail = async ({ email, id }: { email: string, id: number | undefined | null }) => {
    try {
        const response = await axiosInstance.get<GetCustomerDetailResponse>(
            `/kasir/view-customer?email=${email}&cust_id=${id}`
        );

        if (response.data.success) {
            return response.data?.customer || [];
        }
    } catch (error) {
        console.error("getCustomers error:", error);
        throw error;
    }
}